import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs';
import { MailTemplateSendModel } from '../../models/mail/mail-template-send.model';
import { MailTemplateModel } from '../../models/mail/mail-template.model';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { MailFacade } from '../../shared-new/store/mail/mail.facade';

@Component({
  selector: 'app-mail-templates',
  templateUrl: './mail-templates-popup.component.html',
  styleUrls: ['./mail-templates-popup.component.scss']
})
export class MailTemplatesPopupComponent extends BaseUnsubscribeComponent implements OnInit {
  public model: MailTemplateModel;
  form: FormGroup;
  @Input() public data: any;
  constructor(private readonly mailFacade: MailFacade, public readonly modal: NgbActiveModal,) {
    super();
    this.form = MailTemplateModel.asFormGroup(null);
  }
  onSubmit(): void {
    this.model = this.form.value;
    this.model.mailTemplateId = this.data?.templateId;
    this.mailFacade.saveMailTemplate(this.model);
    this.mailFacade.saveMailTemplate$.pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      this.data = response;
      this.closePopup();
    });
  }
  closePopup(): void {
    this.modal.close(JSON.stringify(this.data));
  }
  ngOnInit(): void {
    const id = this.data?.templateId;
    this.mailFacade.getMailTemplate(id);
    this.mailFacade.mailTemplate$.pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      this.form = MailTemplateModel.asFormGroup(response);
    });
  }

}
